import numeral from "numeral";
import React from "react";
import { Pie, Bar } from "react-chartjs-2";
import { useSelector } from "react-redux";
import API from "../../utils/API";
import { isBiro, satuan, singkatan_nama_perusahaan } from "../../utils/helper";

export default (props) => {
  const chartFilter = useSelector((state) => state.chartFilterReducer);
  const chartFilterDashboard = useSelector(
    (state) => state.chartFilterDashboard
  );
  const companies = useSelector(
    (state) => state.perusahaanReducer.listPerusahaan
  );
  const [data, setData] = React.useState([]);
  const [rawData, setRawData] = React.useState([]);
  const [legend, setLegend] = React.useState([]);
  const { year, type, startMonth, endMonth } = chartFilter;
  const [isThereNegative, setIsThereNegative] = React.useState(0);
  const [total, setTotal] = React.useState(0);
  const user = useSelector((state) => state.main.dataUser);
  const optionsPie = {
    legend: {
      display: false
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          const n = tooltipItem.index;
          return data.labels[n];
        },
        footer: (tooltipItems, data) => {
          const n = tooltipItems[0].index;
          return "Rp " + numeral(data.datasets[0].data[n]).format(0, 0);
        }
      }
    }
  };
  const optionsBar = {
    responsive: true,
    legend: {
      display: false
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          const n = tooltipItem.index;
          return data.years[n];
        },
        footer: (tooltipItems, data) => {
          const n = tooltipItems[0].index;
          return "Rp " + numeral(data.datasets[0].data[n]).format(0, 0);
        }
      }
    },
    scales: {
      yAxes: [
        {
          ticks: {
            display: true,
            beginAtZero: true,
            callback: function (val, index) {
              return satuan(val);
            }
          }
        }
      ],
      xAxes: [
        {
          ticks: {
            display: false
          }
        }
      ]
    }
  };

  const getValues = (raws) => {
    let negativeCounter = 0;
    for (const rd of raws) {
      if (rd.value === null || rd.value <= 0) negativeCounter++;
    }
    if (negativeCounter === raws.length) return raws.map((o) => o.value);
    return raws.map((o) => (o.value == null ? 0 : o.value));
  };
  const getData = async () => {
    if (companies.content.length === 0 && isBiro()) {
      var url =
        `/chart/${props.type.url}?startYear=${chartFilterDashboard.startYear}&endYear=${chartFilterDashboard.endYear}&` +
        `type=${chartFilterDashboard.type}&startMonth=${chartFilterDashboard.startMonth}&endMonth=${chartFilterDashboard.endMonth}&perusahaanId=${chartFilterDashboard.bumd}`;

    } else
      var url =
        `/chart/${props.type.url}?startYear=${chartFilterDashboard.startYear}&endYear=${chartFilterDashboard.endYear}&` +
        `type=${chartFilterDashboard.type}&startMonth=${chartFilterDashboard.startMonth}&endMonth=${chartFilterDashboard.endMonth}&perusahaanId=${user.perusahaan == null ? chartFilterDashboard.bumd : user.perusahaan.id}`;


    if (props.url == 1) {
      url = `/chart/${props.type.url}?year=${chartFilterDashboard.endYear}&type=${chartFilterDashboard.type}&startMonth=${chartFilterDashboard.startMonth}&endMonth=${chartFilterDashboard.endMonth}`;
    }

    url = url.trim();
    // const url = `/chart/${props.type.url}?year=${year}&type=${type}&startMonth=${startMonth}&endMonth=${endMonth}`;
    const r = await API.get(url);
    const d = r.data;
    handleSum(d);
    checkThereNegative(r.data);
    const comp = companies.content;
    const chartData = {
      labels: d.map((o) => o.perusahaanName),
      years: d.map((o) => o.year),
      keterangan: d.map((o) => o.catatan),
      datasets: [
        {
          data: getValues(d),
          backgroundColor: isBiro()
            ? d.map(
              (o) => comp.filter((c) => c.id === o.perusahaanId)[0]?.color
            )
            : "#28a745"
        }
      ]
    };

    createDataLegend(chartData);
    setData(chartData);
    setRawData(d);
  };

  const createDataLegend = (par) => {
    if (par) {
      var arrayTitle = par.labels;
      var arrayYear = par.years;
      var arrayKeterangan = par.keterangan;
      var value = par.datasets[0].data;
      var bg = par.datasets[0].backgroundColor;
      var tmp = [];
      for (var i = 0; i < arrayTitle.length; i++) {
        var obj = {
          title: arrayTitle[i],
          year: arrayYear[i],
          value: value[i],
          bg: bg[i],
          ket: arrayKeterangan[i]
        };
        tmp.push(obj);
      }
      setLegend(tmp);
    }
  };

  const checkThereNegative = (data) => {
    if (data) {
      var inc = 0;
      data.map((r, i) => {
        if (r.value < 0) {
          inc++;
          setIsThereNegative(inc);
        }
      });
    }
  };

  const isValidData = () => {
    if (isBiro()) {
      if (rawData.length === 0) return 0;
      let negativeCounter = 0;
      for (const rd of rawData) {
        if (rd.value > 0) return 1;
        else negativeCounter++;
      }
      if (negativeCounter === rawData.length) return 2;
      return 0;
    } else {
      if (rawData[0]?.value === null) return 0;
      if (rawData.length === 0) return 0;
      let negativeCounter = 0;
      for (const rd of rawData) {
        if (rd.value > 0) return 1;
        else negativeCounter++;
      }
      if (negativeCounter === rawData.length) return 2;
      return 0;
    }
  };

  const handleSum = (data) => {
    var total = 0;
    data.map((r, i) => {
      total += r.value;
    });
    total = satuan(total);
    setTotal(total);
  };


  React.useEffect(() => {
    getData();
  }, [
    // chartFilter,
    companies,
    chartFilterDashboard
  ]);
  // const options = {
  //   legend: {
  //     display: false,
  //   },
  // };
  if (data.length === 0) return <></>;
  const circleChart = {
    height: "151px",
    width: "100%",
    backgroundColor: "rgba(160, 160, 160, 0.9)",
    borderRadius: "100%",
    position: "relative"
  };
  const circleChartText = {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    color: "white",
    textAlign: "center"
  };

  if (!isBiro()) {
    return (
      <div className="col-md-4" style={{ marginTop: 20 }}>
        {isValidData() === 0 ? (
          <div style={circleChart}>
            <small style={circleChartText}>data tidak cukup/valid</small>
          </div>
        ) : (
          <div>
            <h5 style={{ textAlign: "end" }}>Total : {total}</h5>
            <Bar data={data} options={optionsBar} width={1} height={1} />
          </div>
        )}
        <p className="font-weight-bold text-center mt-2">
          {props.type.title}
        </p>

        {/* <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap"
          }}
        >
          {legend.map((r, i) => {
            return (
              <div
                key={i}
                style={{
                  marginLeft: 20,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center"
                }}
              >
                <div
                  style={{
                    backgroundColor: "#28a745",
                    height: 10,
                    width: 10,
                    borderRadius: 5,
                    marginRight: 5
                  }}
                />
                <span>
                  {singkatan_nama_perusahaan(r.title)}&nbsp;{r.year}&nbsp;(
                  {satuan(r.value)}) {r.ket == null ? "" : ":"  } {r.ket}
                </span>
              </div>
            );
          })}
        </div> */}
      </div>
    );
  }

  if (
    isThereNegative > 0 ||
    (chartFilterDashboard.bumd !== "" &&
      typeof chartFilterDashboard.bumd == "string")
  ) {
    return (
      <div className="col-md-4" style={{ marginTop: 20 }}>
        {isValidData() === 0 ? (
          <div style={circleChart}>
            <small style={circleChartText}>data tidak cukup/valid</small>
          </div>
        ) : (
          <div>
            <h5 style={{ textAlign: "end" }}>Total : {total}</h5>
            <Bar data={data} options={optionsBar} width={1} height={1} />
          </div>
        )}
        <p className="font-weight-bold text-center mt-2">
          {props.type.title}
        </p>

        {/* <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
          }}
        >
          {legend.map((r, i) => {
            return (
              <div
                key={i}
                style={{
                  marginLeft: 20,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center"
                }}
              >
                <div
                  style={{
                    backgroundColor: r.bg,
                    height: 10,
                    width: 10,
                    borderRadius: 5,
                    marginRight: 5
                  }}
                />
                <span>
                  {singkatan_nama_perusahaan(r.title)}&nbsp;{r.year}&nbsp;(
                  {satuan(r.value)}) {r.ket == null ? "" : ":"  } {r.ket}
                </span>
              </div>
            );
          })}
        </div> */}
      </div>
    );
  }
  return (
    <div className="col-md-4" style={{ marginTop: 20 }}>
      {isValidData() === 0 ? (
        <div style={circleChart}>
          <small style={circleChartText}>data tidak cukup/valid</small>
        </div>
      ) : (
        <div>
          <h5 style={{ textAlign: "end" }}>Total : {total}</h5>
          <Pie data={data} options={optionsPie} width={1} height={1} />
        </div>
      )}
      <p className="font-weight-bold text-center mt-2">
        {props.type.title} {isValidData() === 2 ? "(negative)" : ""}
      </p>
      {/* <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
        }}
      >
        {legend.map((r, i) => {
          return (
            <div
              key={i}
              style={{
                marginLeft: 20,
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
              }}
            >
              <div
                style={{
                  backgroundColor: r.bg,
                  height: 10,
                  width: 10,
                  borderRadius: 5,
                  marginRight: 5
                }}
              />
              <span>
                {singkatan_nama_perusahaan(r.title)}&nbsp;{r.year}&nbsp;(
                {satuan(r.value)})
              </span>
            </div>
          );
        })}
      </div> */}
    </div>
  );
};

